<template>
  <div class="whs-list-icons">
    <div
      v-if="hasIcon('has_internet', info)"
      title="Бесплатный интернет"
      class="whs-icon whs-icon-internet"
    ></div>
    <div v-if="hasIcon('has_parking', info)" title="Парковка" class="whs-icon whs-icon-parking"></div>
    <div v-if="hasIcon('has_meal', info)" title="Бар или ресторан" class="whs-icon whs-icon-meal"></div>
    <div
      v-if="hasIcon('has_pets', info)"
      title="Разрешено с домашними животными"
      class="whs-icon whs-icon-pets"
    ></div>
    <div v-if="hasIcon('has_spa', info)" title="Спа-услуги" class="whs-icon whs-icon-spa"></div>
    <div
      v-if="hasIcon('air-conditioning', info)"
      title="Кондиционер"
      class="whs-icon whs-icon-air-conditioning"
    ></div>
    <div
      v-if="hasIcon('has_bathroom', info)"
      title="Ванная комната в номере"
      class="whs-icon whs-icon-spa"
    ></div>

    <!-- <div v-if="hasIcon('has_smoking', info)" title="Можно курить" class="whs-icon whs-icon-smoking"></div> -->
    <div
      v-if="hasIcon('has_busyness', info)"
      title="Конференц-зал"
      class="whs-icon whs-icon-busyness"
    ></div>
    <div
      v-if="hasIcon('has_airport_transfer', info)"
      title="Трансфер"
      class="whs-icon whs-icon-transfer"
    ></div>
    <div v-if="hasIcon('has_kids', info)" title="Подходит для детей" class="whs-icon whs-icon-kids"></div>
  </div>
</template>

<script>
export default {
  name: 'Icons',
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  methods: {
    hasIcon(prop, info) {
      return info.serp_filters.includes(prop);
    }
  }
};
</script>

<style scoped>
.whs-list-icons {
  display: flex;
  flex-wrap: wrap;
}
.whs-list-icons .whs-icon:before {
  font-size: 18px;
  display: flex;
  width: 24px;
  height: 24px;
  margin: 2px;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.whs-icon-internet:before {
  content: '\f1eb';
}
.whs-icon-parking:before {
  content: '\f540';
}
.whs-icon-meal:before {
  content: '\f2e7';
}
.whs-icon-pets:before {
  content: '\f6d3';
}
.whs-icon-spa:before {
  content: '\f593';
}
.whs-icon-air-conditioning:before {
  content: '\f2dc';
}
.whs-icon-smoking:before {
  content: '\f48d';
}
.whs-icon-busyness:before {
  content: '\f685';
}
.whs-icon-transfer:before {
  content: '\f207';
}
.whs-icon-kids:before {
  content: '\f1ae';
}
</style>
